import Header from '../components/Header'
import React, { useState, useEffect } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import axios from 'axios'

const MaterialsInformation = () => {
  const [materialsData, setMaterialsData] = useState([])
  const { urlKey } = useParams()
  const materialUrlKey = urlKey
  const youtubeUrl = `${materialsData.youtubeLink}?origin=${encodeURIComponent(
      window.location.origin
  )}`;
  useEffect(() => {
    const fetchMaterialsInfo = async () => {
      try {
        const response = await axios.post('/api/module/materialsInformation', {
          urlKey: materialUrlKey
        })

        const data = response.data

        if (response.status === 200) {
          setMaterialsData(data.data)
        } else {
          console.error('Failed to fetch module data')
        }
      } catch (error) {
        console.error('Error fetching module data:', error)
      }
    }

    fetchMaterialsInfo()
  }, [materialUrlKey])

  if (!materialUrlKey) return <Navigate to="/pastlectures" replace />

  return (
    <div>
      <Header />
      <div
        style={{ paddingRight: '25%', paddingLeft: '25%', marginTop: '40px' }}
      >
        <iframe
            width="560"
            height="315"
            src={youtubeUrl}
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            referrerPolicy="strict-origin-when-cross-origin"
            webkitallowfullscreen="true"
            allowfullscreen="true"
        />
        <p style={{ color: '#712E88', fontSize: '20px', fontWeight: '600' }}>
          {materialsData.Title}
        </p>
        {materialsData.speakerBold ? (
          <p style={{ fontWeight: 'bold' }}>{materialsData.speakerBold}</p>
        ) : null}
        {materialsData.textDescription ? (
          <p>{materialsData.textDescription}</p>
        ) : null}
        {materialsData.speaker1 ? (
          <div>
            <ul>
              <li>{materialsData.speaker1}</li>
              <li>{materialsData.speaker2}</li>
              <li>{materialsData.speaker3}</li>
              <li>{materialsData.speaker4}</li>
            </ul>
          </div>
        ) : null}
        {materialsData.moderator ? (
          <div>
            <p style={{ fontWeight: '600' }}>Moderator:</p>
            <p>{materialsData.moderator}</p>
          </div>
        ) : null}
        {materialsData.panellist1 ? (
          <div>
            <li>{materialsData.panellist1}</li>
            <li>{materialsData.panellist2}</li>
            <li>{materialsData.panellist3}</li>
          </div>
        ) : null}

        <img
          style={{ width: '100%', marginTop: '10px' }}
          src={materialsData.imageURL}
          alt="img"
        />
      </div>
    </div>
  )
}

export default MaterialsInformation
